import React from 'react';
import styled from 'styled-components';

import { ErrorBoundary } from '@/components/ErrorBoundary';

interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
    $padding?: number;
    $maxWidth?: string;
}

// eslint-disable-next-line react/display-name
export const Card = React.forwardRef<HTMLDivElement, CardProps>(({ children, ...props }, ref) => (
    <StyledCard ref={ref} {...props}>
        <ErrorBoundary>{children}</ErrorBoundary>
    </StyledCard>
));

const StyledCard = styled.div<{ $padding?: number; $maxWidth?: string }>`
    background-color: ${({ theme }) => theme.container.primaryBackground};
    border: 1px solid ${({ theme }) => theme.border.dark};
    border-radius: 3px;
    padding: ${({ $padding = 16 }) => `${$padding}px`};
    max-width: ${({ $maxWidth }) => $maxWidth};
    overflow: hidden;
    flex-shrink: 0;
`;
